/* eslint-disable */
import { ref, computed, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import axios from "axios";
import moment from "moment";
import customModal from "../customModal/customModal.vue"
import Multiselect from "@vueform/multiselect"
export default {
    name: "SetFhirAlert",
    components: {
        Multiselect,
        customModal
  },
    setup() {      
        const store = useStore();
        const baseurl = ref(process.env.VUE_APP_Service_URL)
        const { d, t, locale } = useI18n({ useScope: "global" });
        let templateList=ref([])
        let templateObj=ref({})
        let selectedFormFields=ref([])
        let currentField = ref({})
        let userList = ref([])
        let initialList = ref([])
        let notificationMethods = ref([]); 
        let selectedResourceTypeCategory = ref([])
        let multiRoleSelectList=ref([])
        let multiNotificationSelect=ref([])
        let getFieldAlertValues=ref([])
        let alertError=ref([false,false,false,false,false,false,false,false])
        let notificationList=ref([
            {label:'Email Notification',value:'Email Notification'},
            {label:'SMS Notification',value:'SMS Notification'},
            {label:'In-App Notification',value:'In-App Notification'}
        ])
        let getAlertValue = ref([{
            id: "",
            studyId: "",
            alertFor: "",
            templateId: "",
            templateName: "",
            fieldName: "",
            fieldLabel: "",
            alertMessage: "",
            priority: "",
            alertType: "",
            notificationMethod: "",
            alertRule: "",
            rule: [
                {
                    "condition": "",
                    "value": [
                       
                    ]
                }
            ],
            dataSource: "",
            active: true,
            rolesToNotify: [
          
            ],
            notificationEmail: [
            ]
            
        }])
        let getFormAlertValue=ref([{
            id: "",
            studyId: "",
            alertFor: "",
            templateId: "",
            templateName: "",
            fieldName: "",
            fieldLabel: "",
            alertMessage: "",
            priority: "",
            alertType: "",
            notificationMethod: "",
            alertRule: "",
            rule: [
                {
                    "condition": "",
                    "value": [
                       
                    ]
                }
            ],
            dataSource: "",
            active: true,
            rolesToNotify: [
          
            ],
            notificationEmail: [
            ]
            
        }])
        let newAlert = ref({
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                alertType: "",
                notificationMethod: "",
                alertRule: "",
                rule: [
                    {
                    condition: "",
                    value: [
                        ""
                    ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    
                ],
                notificationEmail: [
                    
                ]
        })
        // Selected filters
        const selectedTemplate = ref('');
        let alertCategories=ref('');
        let selectedCategory=ref('')
        let alertModal = ref(false);
        let alertFormModal = ref(false);
        let viewAlertLoading = ref(false);
        let viewAlert = ref(false);
        let showFieldsLoader = ref(false);
        let viewAlertFormModal = ref(false)
        let radiooptionsarray = ref(false)
        const viewAlertModal = ref(null);
        let conditionsArray = ref([])
        let roleList = ref([])
        let conditionalRules= ref([{
            condition: "",
            value: []
        }
        ])
        let conditionValues=ref([
             {label:"Equals", value:"EQUALS"},     
             {label:"Not equal to",value:"NOT EQUAL TO"},
            {label:"Greater than",value:"GREATER THAN"},
            {label:"Greater than or equal to",value:"GREATER THAN OR EQUAL TO"},
            {label:"Less than",value:"LESS THAN"},
            {label:"Less than or equal to",value:"LESS THAN OR EQUAL TO"},        
            {label:"Contains",value:"CONTAINS"},
            {label:"Missing",value:"MISSING"}
        ])
        let textboxOptions= ref([
        { value: "NOT EQUAL TO", label: "Not equal to" },
        { value: "EQUAL TO", label: "Equal to" },
      ])
      let radioOptions= ref([
        { value: "EQUAL TO", label: "Equal to" },
        { value: "NOT EQUAL TO", label: "Not equal to" },
      ])
      let dropdownOptions= ref([
        { value: "NOT EQUAL TO", label: "Is not" },
        { value: "EQUAL TO", label: "Is equal to" },
      ])
      let checkboxOptions=ref([
        { value: "IS CHECKED ON", label: "Is checked on" },
        { value: "IS CHECKED OFF", label: "Is checked off" },
      ])
      let dateOptions=ref([
        { value: "DATE GREATER THAN", label: "Is greater than" },
        { value: "DATE GREATER THAN OR EQUAL TO", label: "Is greater than or equal to" },
        { value: "DATE EQUAL TO", label: "Is equal to" },
        { value: "DATE LESS THAN", label: "Is smaller than" },
        { value: "DATE LESS THAN OR EQUAL TO", label: "Is smaller than or equal to" },
        { value: "DATE NOT EQUAL TO", label: "Not" },
        { value: "OPTION TO AUTOFILL CURRENT DATE", label: "Option to autofill current date" }
      ])
      let yearOptions= ref([
        { value: "GREATER THAN", label: "Is greater than" },
        { value: "GREATER THAN OR EQUAL TO", label: "Is greater than or equal to" },
        { value: "EQUAL TO", label: "Is equal to" },
        { value: "LESS THAN", label: "Is smaller than" },
        { value: "LESS THAN OR EQUAL TO", label: "Is smaller than or equal to" },
        { value: "NOT EQUAL TO", label: "Not" },
      ])
      let scaleOptions= ref([
        { value: "GREATER THAN", label: "Is greater than" },
        { value: "GREATER THAN OR EQUAL TO", label: "Is greater than or equal to" },
        { value: "EQUAL TO", label: "Is equal to" },
        { value: "LESS THAN", label: "Is smaller than" },
        { value: "LESS THAN OR EQUAL TO", label: "Is smaller than or equal to" },
        { value: "NOT EQUAL TO", label: "Not" },
      ])
      let textareaOptions= ref([
        { value: "NOT EQUAL TO", label: "Is not" },
        { value: "EQUAL TO", label: "Is equal to" },
        { value: "REQUIRED", label: "Required" },
      ])
        
        onMounted(async () => {           
            window.addEventListener("studyIdChanged", (event) => {
              selectedFormFields.value=[]
              setRoleList()
            });
             getFHIRResourceType()
             setRoleList()
             getAlertCategories()
        })
        function validatePossibleInput(event){
            let value = event.target.value;
            const invalidChars = ['e', 'E', '+', '-', '.'];
            if (invalidChars.includes(event.key)) {
                event.preventDefault();
            }
            else{
                // Remove any non-numeric characters
            value = value.replace(/[^0-9]/g, "");

            // Convert to number
            if (value) {
                value = parseInt(value, 10)
            }
            }
            
            }
         function getFHIRResourceType(){
            const idtoken = store.getters.getIdToken;
            axios
            .get(`${baseurl.value}/forms/alert/getfhirresources`, {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            },
            })
            .then((res) => {
                initialList.value=res.data.entities
                templateList.value=res.data.entities.map(item => item.resourceType)
            })
            .catch(async (err) => {
            console.log(err);
            });
        }
        function addRow(type,index){
            if(type=='get'){
                conditionalRules.value.push(
                    {
                        condition: "",
                        value: []
                    }
                    )
                }
            else{
                 conditionalRules.value[index].push(
                    {
                        condition: "",
                        value: []
                    }
                    )
                }
        }
        
        function deleteFilter(index) {
            conditionalRules.value.splice(index, 1);
        }
        function getFHIRResourceChange(id){
            initialList.value.forEach((item) => {
            if (item.resourceType == id && item.categories) {
                selectedResourceTypeCategory.value=item.categories
            }
            });        
            selectedFormFields.value=[]
            selectedCategory.value=""
        } 
        function getFHIRCategoryChange (){
            showFieldsLoader.value=true
            selectedResourceTypeCategory.value.forEach((item) => {
            if (item.display == selectedCategory.value) {
                selectedFormFields.value=item.fields
                showFieldsLoader.value=false
                getFieldDetails()
                return
            }
            })
        }
        function openViewAlertFormModal(){
            getFormAlertById()      
            viewAlertFormModal.value=true
        }
        function openViewAlertModal(field){     
            getAlertById(field)      
            viewAlert.value=true
            currentField.value = field;   
        }
        function clearNotification(index){
            if(index){
                multiNotificationSelect[index]=[]
            }else multiNotificationSelect=[]
            
        }
        function clearData(){
              newAlert.value = {
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                days:"",
                triggerType:"",
                alertType: "",
                notificationMethod: [
                    ""
                ],
                alertRule: "",
                rule: [
                    {
                    condition: "",
                    value: [
                        ""
                    ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    ""
                ],
                notificationEmail: [
                    ""
                ],
                triggerType: "",
                days: "",
                targetDate: ""
             }
        }
         function getFormAlertById()
        {          
            viewAlertLoading.value=true
            const idtoken = store.getters.getIdToken;
            axios
            .get(`${baseurl.value}/forms/alert/getalll?TemplateId=${selectedTemplate.value}`,
            {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
                },
             })
            .then((res) => {
                viewAlertLoading.value=false
                getFormAlertValue.value=res.data.entities
               res.data.entities.forEach((item, index) => {
                // Ensure the slot exists
                if (!conditionalRules.value[index]) {
                    conditionalRules.value[index] = {   
                        condition: "",
                        value: [] };
                }

                if (Array.isArray(item.rule) && item.rule.length > 0) {
                    conditionalRules.value[index] = item.rule;
                } else {
                    conditionalRules.value[index] = [
                    {
                        condition: '',
                        value: []
                    }
                    ];
                }
                    if(!multiRoleSelectList.value[index]){
                        multiRoleSelectList.value[index]=[]
                    }
                    if (Array.isArray(item.rolesToNotify) && item.rolesToNotify.length > 0)
                    {
                        multiRoleSelectList.value[index] = item.rolesToNotify
                        getAlertRoleBasedUserlist(index)
                    }
                    else {
                        multiRoleSelectList.value[index] = []
                    }
                     if(!multiNotificationSelect.value[index]){
                        multiNotificationSelect.value[index]=[]
                    }
                    if (Array.isArray(item.notificationMethod) && item.notificationMethod.length > 0)
                    {
                        multiNotificationSelect.value[index] = item.notificationMethod
                    }
                    else {
                        multiNotificationSelect.value[index] = []
                    }
                });

                
            })
            .catch(async (err) => {
                viewAlertLoading.value=false
                // console.log(err);
            });
        }
            
        function getAlertById(field)
        {
            conditionsArray.value = conditionValues.value                          
            viewAlertLoading.value=true
            const idtoken = store.getters.getIdToken;
            axios
            .get(`${baseurl.value}/forms/alert/getalll?TemplateId=&FieldName=${field ? field.display : ''}`,
            {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
                },
             })
            .then((res) => {
                viewAlertLoading.value=false
                getAlertValue.value=res.data.entities
               res.data.entities.forEach((item, index) => {
                // Ensure the slot exists
                if (!conditionalRules.value[index]) {
                    conditionalRules.value[index] = {   
                        condition: "",
                        value: [] };
                }

                if (Array.isArray(item.rule) && item.rule.length > 0) {
                    conditionalRules.value[index] = item.rule;
                } else {
                    conditionalRules.value[index] = [
                    {
                        condition: '',
                        value: []
                    }
                    ];
                }
                    if(!multiRoleSelectList.value[index]){
                        multiRoleSelectList.value[index]=[]
                    }
                    if (Array.isArray(item.rolesToNotify) && item.rolesToNotify.length > 0)
                    {
                        multiRoleSelectList.value[index] = item.rolesToNotify
                        getAlertRoleBasedUserlist(index)
                    }
                    else {
                        multiRoleSelectList.value[index] = []
                    }
                    if(!multiNotificationSelect.value[index]){
                        multiNotificationSelect.value[index]=[]
                    }
                    if (Array.isArray(item.notificationMethod) && item.notificationMethod.length > 0)
                    {
                        multiNotificationSelect.value[index] = item.notificationMethod
                    }
                    else {
                        multiNotificationSelect.value[index] = []
                    }
                });

                
            })
            .catch(async (err) => {
                viewAlertLoading.value=false
                // console.log(err);
            });
        }
        function openSetAlertForm(){
            alertFormModal.value=true
        }
        function closeAlertFormModal(){
            alertFormModal.value=false
            multiNotificationSelect.value=[]
            multiRoleSelectList=[]
           newAlert.value = {
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                days:"",
                triggerType:"",
                alertType: "",
                notificationMethod: [
                    ""
                ],
                alertRule: "",
                rule: [
                    {
                    condition: "",
                    value: [
                        ""
                    ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    ""
                ],
                notificationEmail: [
                    ""
                ],
                triggerType: "",
                days: "",
                targetDate: ""
             }
        }
        function openSetAlertModal(field){
            alertModal.value=true
            currentField.value = field;    
            conditionalRules.value[0].value[0]=field.value          
            conditionsArray.value = conditionValues.value;
                 
        }
         async function getAlertCategories() {
            try {
                const idtoken = store.getters.getIdToken;
                const res = await axios.get(
                    `${baseurl.value}/forms/alert/getalertcategorys`,
                    { headers: { Authorization: "Bearer " + idtoken } }
                );
                alertCategories.value = res.data.entities.map(item => item.category);
            } catch (error) {
                console.error("Error fetching alert categories:", error);
            }
        }
        function saveFormAlert(){
            newAlert.value.studyId=store.getters.getStudyIs
            newAlert.value.templateId=selectedTemplate.value
            newAlert.value.fieldName=currentField.value.fieldName
            newAlert.value.fieldLabel=currentField.value.label
            newAlert.value.rolesToNotify=multiRoleSelectList.value
            newAlert.value.templateName = templateObj.value.templateName
            newAlert.value.alertFor="Form"
            newAlert.value.notificationMethod=multiNotificationSelect.value
            newAlert.value.rule[0].condition=newAlert.value.alertRule
            newAlert.value.rule[0].value[0]= newAlert.value.rule[0].value[0] ?  newAlert.value.rule[0].value[0].toString() : ""
            try {
                const idtoken = store.getters.getIdToken;
                 axios.post(
                    `${baseurl.value}/forms/alert/insert`,
                    newAlert.value,
                    { headers: { Authorization: "Bearer " + idtoken } }
                );
                alert("Alert added successfully");
                closeAlertFormModal();
            } catch (error) {
                console.error("Error adding alert rule:", error);
                alert("Failed to add alert rule");
            }
        
        }
        function getFieldDetails(){
            viewAlertLoading.value=true
            const idtoken = store.getters.getIdToken;
            axios
            .get(`${baseurl.value}/forms/alert/getalll?AlertFor=FHIR`,
            {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
                },
             })
            .then((res) => {
                viewAlertLoading.value=false
                getFieldAlertValues.value=res.data.entities            
            })
            .catch((err) => {
                viewAlertLoading.value=false
                console.log(err);
            });
        }
        function hasAlert(fieldLabel) {
            const alert = getFieldAlertValues.value.find(item => item.fieldName === fieldLabel);
            return alert && alert.rule && alert.rule.length > 0;
        }
         function setAlertValidations(type) {         
            if(type=='add')
            {
                const validations = [
                    { condition: newAlert.value.alertType === '', index: 0 },
                    { condition: newAlert.value.priority === '', index: 1 },
                    { condition: newAlert.value.alertRule === '', index: 2 },
                    { condition: newAlert.value.alertMessage === '', index: 3 },
                    { condition: multiNotificationSelect.value.length === 0, index: 4 },
                    { condition: multiRoleSelectList.value.length === 0, index: 5 },
                    { condition: newAlert.value.notificationEmail.length === 0, index: 6 },
                ]   ;

            // Reset all basic error flags
            alertError.value = new Array(validations.length).fill(false);

            // Set basic validations
            validations.forEach(({ condition, index }) => {
                if (condition) {
                alertError.value[index] = true;
                }
            });

            // Additional validation for conditional rules
            if (newAlert.value.alertRule === 'Condition') {
                let hasConditionalError = false;

                for (let i = 0; i < conditionalRules.value.length; i++) {
                const rule = conditionalRules.value[i];

                if (!rule.condition || rule.condition === '') {
                    hasConditionalError = true;
                    break;
                }

                if (!rule.value || !rule.value[0] || rule.value[0].toString().trim() === '') {
                    hasConditionalError = true;
                    break;
                }
                }

                // You can push a separate error flag for conditionalRules (optional index 7)
                if (hasConditionalError) {
                alertError.value[7] = true; // Extend alertError array if needed in template
                }
            }
            }
            else
            {
                alertError.value = getAlertValue.value.map(() => ({
                    alertType: false,
                    priority: false,
                    alertRule: false,
                    alertMessage: false,
                    notifications: false,
                    roles: false,
                    emails: false,
                    conditionals: false
                }));

                let allValid = true;

                getAlertValue.value.forEach((form, index) => {
                    const error = alertError.value[index];

                    if (!form.alertType) {
                    error.alertType = true;
                    allValid = false;
                    }

                    if (!form.priority) {
                    error.priority = true;
                    allValid = false;
                    }

                    if (!form.alertRule) {
                    error.alertRule = true;
                    allValid = false;
                    }

                    if (!form.alertMessage || form.alertMessage.trim() === '') {
                    error.alertMessage = true;
                    allValid = false;
                    }

                    if (!multiNotificationSelect.value[index] || multiNotificationSelect.value[index].length === 0) {
                    error.notifications = true;
                    allValid = false;
                    }

                    if (!multiRoleSelectList.value[index] || multiRoleSelectList.value[index].length === 0) {
                    error.roles = true;
                    allValid = false;
                    }

                    if (!form.notificationEmail || form.notificationEmail.length === 0) {
                    error.emails = true;
                    allValid = false;
                    }

                    // Conditional rules validation if alertRule is 'Condition'
                    if (form.alertRule === 'Condition') {
                    const rules = conditionalRules.value[index];
                    if (!rules || rules.length === 0) {
                        error.conditionals = true;
                        allValid = false;
                    } else {
                        for (const rule of rules) {
                        if (!rule.condition || rule.condition === '' || !rule.value || !rule.value[0] || rule.value[0].toString().trim() === '') {
                            error.conditionals = true;
                            allValid = false;
                            break;
                        }
                        }
                    }
                    }
                });

                return allValid; // Optional if you want to gate save logic with this

            }
          
        }
        function saveAlert() {
            setAlertValidations('add')
            if(!alertError.value.includes(true)){
                newAlert.value.studyId=store.getters.getStudyIs
                newAlert.value.templateId=""
                newAlert.value.fieldName=currentField.value.display
                newAlert.value.fieldLabel=""
                newAlert.value.rule=conditionalRules.value
                newAlert.value.alertFor="FHIR"
                if(newAlert.value.alertRule=='Condition'){
                    newAlert.value.rule=conditionalRules.value
                }    
                newAlert.value.rolesToNotify=multiRoleSelectList.value
                newAlert.value.notificationMethod=multiNotificationSelect.value
                newAlert.value.templateName =""
                try {
                    const idtoken = store.getters.getIdToken;
                    axios.post(
                        `${baseurl.value}/forms/alert/insert`,
                        newAlert.value,
                        { headers: { Authorization: "Bearer " + idtoken } }
                    );
                    alert("Alert added successfully");
                    closeAlertModal();
                    getFieldDetails()
                } catch (error) {
                    console.error("Error adding alert rule:", error);
                    alert("Failed to add alert rule");
                }
            }
        }
        function updateAlert(index,id) {
            setAlertValidations('view')
            if (!Object.values(alertError.value[index]).includes(true)){
            getAlertValue.value[index].studyId=store.getters.getStudyIs
            getAlertValue.value[index].templateId=""
            getAlertValue.value[index].fieldName=currentField.value.fieldName
            getAlertValue.value[index].fieldLabel=currentField.value.label
            getAlertValue.value[index].rule=conditionalRules.value[index]
            getAlertValue.value[index].rolesToNotify=multiRoleSelectList.value[index].
            getAlertValue.value[index].notificationMethod=multiNotificationSelect.value[index].
            getAlertValue.value[index].templateName = ""
            getAlertValue.value[index].id=""
            try {
                const idtoken = store.getters.getIdToken;
                 axios.put(
                    `${baseurl.value}/forms/alert/update`,
                    getAlertValue.value[index],
                    { headers: { Authorization: "Bearer " + idtoken } }
                );
                alert("Alert updated successfully");
            } catch (error) {
                console.error("Error adding alert rule:", error);
                alert("Failed to add alert rule");
            }
        }
        }
        function clearAlertArray(type,index){
            clearNotification(index)
            getAlertClear(index)
                getAlertValue.value[index] = {
                    id: "",
                    studyId: "",
                    alertFor: "",
                    templateId: "",
                    templateName: "",
                    fieldName: "",
                    fieldLabel: "",
                    alertMessage: "",
                    priority: "",
                    targetDate:"",
                    days:"",
                    triggerType:"",
                    alertType: "",
                    notificationMethod: [
                        ""
                    ],
                    alertRule: "",
                    rule: [
                        {
                        condition: "",
                        value: [
                            ""
                        ]
                        }
                    ],
                    dataSource: "",
                    active: true,
                    rolesToNotify: [
                        ""
                    ],
                    notificationEmail: [
                        ""
                    ],
                    triggerType: "",
                    days: "",
                    targetDate: ""
                
            }
            
        }
        function deleteAlertArray(index){
            if(confirm(t("navigations.are you sure you want to delete this alert")))
            {
                const idtoken = store.getters.getIdToken
                axios
                .delete(`${baseurl.value}/forms/alert/delete?id=${getAlertValue.value[index].id}`,
                {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    getAlertValue.value.splice(index, 1);  
                    alert(t("navigations.alert deleted successfully"))       
                    if(getAlertValue.value.length==0){
                        getFieldDetails()
                        selectedFormFields.value=selectedFormFields.value
                    }    
                })
                .catch((err) => {
                    onsole.log(err);
                });           
            }
        }
        function onClear(){
            multiRoleSelectList.value=[]
            userList.value=[]  
        }
        function onRecipientClear(){
             userList.value=[]  
        }
        function onSelectClosed(){
            getRoleBasedUserlist();
           
        }
        function setRoleList() {
            const idtoken = store.getters.getIdToken;
             axios
                .get(
                `${baseurl.value}/account-core/roles/rolelist`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                ).then((res) => {
                    roleList.value = res.data;
                })
        }
        function getRoleBasedUserlist() {
            userList.value=[];
            const idtoken = store.getters.getIdToken;
            if(multiRoleSelectList && multiRoleSelectList.value.length>0){
               const fullroleids = multiRoleSelectList.value.join(',');
                axios
                .get(
                `${baseurl.value}/account-core/user/getusersbyrole?roleids=${fullroleids}&&studyid=${store.getters.getStudyIs}`,{
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                     userList.value = res.data           
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                userList.value =[];
            }
        }
        function getAlertClear(index){
            multiRoleSelectList.value[index]=[]
            userList.value[index]=[]  
        }
        function getAlertRecipientClear(index){
             userList.value[index]=[]  
        }
        function getAlertSelectClosed(index){
            getAlertRoleBasedUserlist(index);
           
        }
        function getAlertRoleBasedUserlist(index) {
            userList.value=[];
            const idtoken = store.getters.getIdToken;
            if(multiRoleSelectList.value[index] && multiRoleSelectList.value[index].length>0){
               const fullroleids = multiRoleSelectList.value[index].join(',');
                axios
                .get(
                `${baseurl.value}/account-core/user/getusersbyrole?roleids=${fullroleids}&&studyid=${store.getters.getStudyIs}`,{
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                     userList.value[index] = res.data           
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                userList.value[index] =[];
            }
        }

         function closeAlertModal(){
           alertModal.value=false
            multiRoleSelectList.value=[]
           userList.value=[]
           conditionalRules.value=[{        
                condition: "",
                value: []
            }]
             alertError.value=[false,false,false,false,false,false,false,false]
            newAlert.value = {
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                alertType: "",
                notificationMethod: "",
                alertRule: "",
                rule: [
                    {
                    condition: "",
                    value: [
                        ""
                    ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    ""
                ],
                notificationEmail: [
                    
                ],
                   triggerType: "",
                    days: "",
                    targetDate: ""
            }
        }
        function closeViewFormAlertModal(){
           viewAlertFormModal.value=false
           multiRoleSelectList.value=[]
            multiNotificationSelect.value=[]
           userList.value=[]
           conditionalRules.value=[{        
                condition: "",
                value: []
            }]
          newAlert.value = {
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                days:"",
                triggerType:"",
                alertType: "",
                notificationMethod: [
                    ""
                ],
                alertRule: "",
                rule: [
                    {
                    condition: "",
                    value: [
                        ""
                    ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    ""
                ],
                notificationEmail: [
                    ""
                ],
                triggerType: "",
                days: "",
                targetDate: ""
             }
        }   
        function closeViewAlertModal(){
           viewAlert.value=false
           multiRoleSelectList.value=[]
            multiNotificationSelect.value=[]
           userList.value=[]
           conditionalRules.value=[{        
                condition: "",
                value: []
            }]
             newAlert.value = {
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                days:"",
                triggerType:"",
                alertType: "",
                notificationMethod: [
                    ""
                ],
                alertRule: "",
                rule: [
                    {
                    condition: "",
                    value: [
                        ""
                    ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    ""
                ],
                notificationEmail: [
                    ""
                ],
                triggerType: "",
                days: "",
                targetDate: ""
             }
        }   
        return {
            // Data properties
            showFieldsLoader,
            viewAlertModal,
            alertModal,
            alertFormModal,
            selectedTemplate,
            viewAlert,
            templateObj,
            baseurl,
            templateList,
            selectedFormFields,
            currentField,
            newAlert,
            userList,
            viewAlertLoading,
            getAlertValue,
            getFormAlertValue,
            textboxOptions,
            radioOptions,
            dropdownOptions,
            checkboxOptions,
            dateOptions,
            yearOptions,
            scaleOptions,
            textareaOptions,
            conditionsArray,
            conditionalRules,
            roleList,
            multiRoleSelectList,
            viewAlertFormModal,
            radiooptionsarray,
            alertCategories,
            notificationList,
            multiNotificationSelect,
            selectedResourceTypeCategory,
            selectedCategory,
            initialList,
            conditionValues,
            getFieldAlertValues,
            alertError,
            // Computed properties
            // Methods
            deleteAlertArray,
            getFHIRResourceType,
            getFHIRResourceChange,
            closeAlertModal,
            closeViewAlertModal,
            closeAlertFormModal,
            openSetAlertForm,
            openSetAlertModal,
            openViewAlertModal,
            saveAlert,
            updateAlert,
            addRow,
            deleteFilter,
            setRoleList,
            getRoleBasedUserlist,
            onClear,
            onSelectClosed,
            onRecipientClear,
            getAlertRoleBasedUserlist,
            getAlertSelectClosed,
            getAlertRecipientClear,
            getAlertClear,
            clearData,
            validatePossibleInput,
            saveFormAlert,
            openViewAlertFormModal,
            getFormAlertById,
            closeViewFormAlertModal,
            getAlertCategories,
            clearNotification,
            getFHIRCategoryChange,
            getFieldDetails,
            hasAlert,
            clearAlertArray
        };
    }
};